import { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import moment from 'moment';
import DownwardsArrowComponent from '../../shared_components/DownwardsArrowComponent';

class SavingsOverviewRowComponent extends Component {
  render() {
    const {
      date,
      remainingDebt,
      interest,
      month,
      gross,
      repayment,
      monthlyPayment,
      showSetRangeButton,
      rotatedWithinRangeArrow,
    } = this.props;

    let setRangeButton = (<td />);
    let rotateButtonClassName = '';

    if (rotatedWithinRangeArrow) {
      rotateButtonClassName = 'savings-container__table__set-range-button--rotated';
    }

    if (showSetRangeButton) {
      setRangeButton = (
        <td>
          <button
            onClick={() => {
              this.props.setRange(month);
            }}
            className={`savings-container__table__set-range-button ${rotateButtonClassName}`}
          >
            <DownwardsArrowComponent />
          </button>

        </td>
      );
    }

    const dutchMonth = moment(date).format('MMMM');

    return (
      <tr>
        <td>{date.substr(0, 4)} ({dutchMonth})</td>
        <td>{numeral(remainingDebt).format('$ 0,00')}</td>
        <td>{numeral(interest / 100).format('%0.00')}</td>
        <td />
        <td>{numeral(gross).format('$ 0,00')}</td>
        <td>{numeral(repayment).format('$ 0,00')}</td>
        <td>{numeral(monthlyPayment).format('$ 0,00')}</td>
        {setRangeButton}
      </tr>
    );
  }
}

SavingsOverviewRowComponent.propTypes = {
  date: PropTypes.string,
  month: PropTypes.number,
  remainingDebt: PropTypes.number,
  interest: PropTypes.number,
  gross: PropTypes.number,
  repayment: PropTypes.number,
  monthlyPayment: PropTypes.number,
  showSetRangeButton: PropTypes.bool,
  rotatedWithinRangeArrow: PropTypes.bool,
  setRange: PropTypes.func,
};

SavingsOverviewRowComponent.defaultProps = {
  date: '',
  month: '',
  remainingDebt: '',
  interest: '',
  gross: '',
  repayment: '',
  monthlyPayment: '',
  showSetRangeButton: false,
  rotatedWithinRangeArrow: false,
  setRange: () => {},
};

export default SavingsOverviewRowComponent;
